/* Widerrufsformular – Theme Asset */
(function () {
  'use strict';

  var cfg = window.__WF_CONFIG__ || {};
  var endpoint = cfg.endpoint || '';

  // Toast-Container
  var toastEl = document.createElement('div');
  toastEl.className = 'wf-toast-container';
  document.body.appendChild(toastEl);

  function toast(msg, type) {
    var el = document.createElement('div');
    el.className = 'wf-toast wf-toast--' + (type || 'success');
    var icon = type === 'error'
      ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="#ef5350"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>'
      : '<svg width="18" height="18" viewBox="0 0 24 24" fill="#4cbb17"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>';
    el.innerHTML = icon + '<span>' + msg + '</span>';
    toastEl.appendChild(el);
    setTimeout(function () { el.remove(); }, 5000);
  }

  function setStep(n) {
    for (var i = 1; i <= 3; i++) {
      var s = document.querySelector('[data-step="' + i + '"]');
      if (!s) continue;
      s.classList.remove('wf-step--active', 'wf-step--done');
      if (i < n) s.classList.add('wf-step--done');
      if (i === n) s.classList.add('wf-step--active');
    }
    for (var j = 1; j <= 2; j++) {
      var l = document.getElementById('wf-line-' + j);
      if (l) l.classList.toggle('wf-step__line--done', j < n);
    }
  }

  function clearErrors() {
    document.querySelectorAll('.wf-group--error').forEach(function (g) {
      g.classList.remove('wf-group--error');
    });
  }

  function markError(id) {
    var g = document.getElementById('wf-g-' + id);
    if (g) g.classList.add('wf-group--error');
  }

  function validate(form) {
    clearErrors();
    var ok = true;

    function req(fieldId, test) {
      var el = document.getElementById('wf-' + fieldId);
      if (!el) return;
      if (!test(el.value)) { markError(fieldId); ok = false; }
    }

    req('vorname',      function (v) { return v.trim().length >= 2; });
    req('nachname',     function (v) { return v.trim().length >= 2; });
    req('email',        function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); });
    req('bestelldatum', function (v) { return v !== ''; });

    var ds = document.getElementById('wf-datenschutz');
    if (ds && !ds.checked) { markError('datenschutz'); ok = false; }

    var art = form.querySelector('input[name="widerrufsart"]:checked');
    if (art && art.value === 'Teilwiderruf') {
      var prod = document.getElementById('wf-produkte');
      if (prod && !prod.value.trim()) { markError('produkte'); ok = false; }
    }

    return ok;
  }

  function showSuccess(ref) {
    setStep(3);
    var f = document.getElementById('wf-form');
    var p = document.getElementById('wf-success');
    if (f) f.hidden = true;
    if (p) {
      p.hidden = false;
      var n = document.getElementById('wf-refnum');
      if (n) n.textContent = ref || '–';
    }
    var root = document.getElementById('wf-root');
    if (root) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Referenznummer clientseitig erzeugen (für Formspree-Submissions ohne Server)
  function genRef() {
    return 'WID-' + Date.now().toString(36).toUpperCase();
  }

  // Datum-Hinweis
  var dateEl = document.getElementById('wf-bestelldatum');
  var hintEl = document.getElementById('wf-datum-hint');
  if (dateEl && hintEl) {
    dateEl.setAttribute('max', new Date().toISOString().split('T')[0]);
    dateEl.addEventListener('change', function () {
      if (!this.value) { hintEl.textContent = ''; return; }
      var diff = Math.floor((Date.now() - new Date(this.value)) / 86400000);
      var deadline = new Date(this.value);
      deadline.setDate(deadline.getDate() + 14);
      if (diff > 14) {
        hintEl.style.color = '#d32f2f';
        hintEl.textContent = '⚠ Widerrufsfrist möglicherweise abgelaufen (' + diff + ' Tage seit Bestellung).';
      } else {
        var rem = 14 - diff;
        hintEl.style.color = '#3a9912';
        hintEl.textContent = '✓ Noch ' + rem + ' Tag' + (rem !== 1 ? 'e' : '') + ' bis ' + deadline.toLocaleDateString('de-DE') + '.';
      }
    });
  }

  // Zeichenzähler
  var grund = document.getElementById('wf-grund');
  var counter = document.getElementById('wf-count');
  if (grund && counter) {
    grund.addEventListener('input', function () { counter.textContent = this.value.length; });
  }

  // Teilwiderruf-Toggle
  document.querySelectorAll('input[name="widerrufsart"]').forEach(function (r) {
    r.addEventListener('change', function () {
      var g = document.getElementById('wf-g-produkte');
      if (g) g.style.display = this.value === 'Teilwiderruf' ? 'block' : 'none';
    });
  });

  // Fortschritt-Update bei Eingabe
  ['vorname', 'nachname', 'email', 'bestellnummer', 'kundennummer'].forEach(function (id) {
    var el = document.getElementById('wf-' + id);
    if (el) el.addEventListener('blur', function () { setStep(1); });
  });
  ['bestelldatum', 'grund'].forEach(function (id) {
    var el = document.getElementById('wf-' + id);
    if (el) el.addEventListener('blur', function () { setStep(2); });
  });

  // Submit
  var form = document.getElementById('wf-form');
  var btn  = document.getElementById('wf-submit');
  if (!form || !btn) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    if (!validate(form)) {
      toast('Bitte füllen Sie alle Pflichtfelder korrekt aus.', 'error');
      return;
    }

    btn.disabled = true;
    btn.classList.add('wf-btn--loading');

    var ref  = genRef();
    var data = { _referenznummer: ref };
    new FormData(form).forEach(function (v, k) { data[k] = v; });

    // Kein Endpoint → Fallback: Formular als mailto öffnen
    if (!endpoint) {
      btn.disabled = false;
      btn.classList.remove('wf-btn--loading');
      showSuccess(ref);
      toast('Widerruf wurde lokal bestätigt. Bitte konfigurieren Sie einen Form-Endpoint.', 'success');
      return;
    }

    // Formspree erwartet JSON oder FormData; wir schicken JSON
    fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, json: j }; });
      })
      .then(function (res) {
        if (!res.ok) {
          // Formspree gibt Fehler in res.json.errors zurück
          var msg = (res.json.errors && res.json.errors[0] && res.json.errors[0].message)
            || res.json.error
            || 'Fehler beim Einreichen';
          throw new Error(msg);
        }
        // Eigener Server gibt referenznummer zurück; Formspree nicht
        var serverRef = (res.json && res.json.referenznummer) || ref;
        showSuccess(serverRef);
      })
      .catch(function (err) {
        toast(err.message || 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.', 'error');
      })
      .finally(function () {
        btn.disabled = false;
        btn.classList.remove('wf-btn--loading');
      });
  });

})();
